import { ExtrudeFeatureSessionBridge } from './ExtrudeFeatureSessionBridge';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/edit/extrude 层；
 * 2. 负责提供凸台拉伸的薄桥接子类；
 * 3. 共享桥接能力已下沉到 `ExtrudeFeatureSessionBridge`，本类只固化 boss 语义。
 *
 * 文件职责：
 * 1. 固定凸台拉伸的 `featureKind / operation`；
 * 2. 作为外部兼容入口，继续承接既有 boss 命名调用点；
 * 3. 避免上层直接依赖抽象基类的构造细节。
 */
export class BossExtrudeFeatureSessionBridge extends ExtrudeFeatureSessionBridge {
    /**
     * 构造凸台拉伸桥接层。
     */
    public constructor() {
        super({
            featureKind: 'boss-extrude',
            operation: 'boss',
        });
    }
}

export type {
    ExtrudeExecutionInput as BossExtrudeExecutionInput,
    ExtrudeSessionRegionInput as BossExtrudeSessionRegionInput,
    ExtrudeSessionSelection as BossExtrudeSessionSelection,
    ExtrudeSessionTarget as BossExtrudeSessionTarget,
} from './ExtrudeFeatureSessionBridge';
